define('controllers/common/iframe-help.ctrl',['app'],function(app){
    app.controller('IframeHelp',['$scope','$sce',function($scope,$sce){
        AUI.HDGWCall.checkLogin(function () {
                //打开问题列表页
                $scope.iframeHelpUrl =$sce.trustAsResourceUrl(sysUrlCfg.esdk.confirmTicket);
        });
    }]);
});
